import React, { useEffect } from "react";

import { Backtotop, Floatinmenu, Underline, Reunion_card } from "../../widgets";
import "../Library/Other_facility.css";
import { RadialMenu, Listformat } from "../../components";
import {
  librarymenu,
  libraryfacility,
} from "../../constants/library";
import {FaBook} from "react-icons/fa";
import "./Other_facility.css";
export default function Other_facility() {
  useEffect(() => {
    document.title = "ACCET-Library | Other facilities";
  }, []);

  return (
    <>
      <div className="librarypage">
        <div className="librarybg">
          <div className="libraryheading">Library</div>
          <div className="library_sub_heading">Other Facilities</div>
        </div>
      </div>
      <section className="librarydark">
        <div className="dept_float_menu">
          <Floatinmenu logo={FaBook} head="Menu" links={librarymenu} />
        </div>
        <RadialMenu menu_links={librarymenu} />
      </section>
      <Backtotop />
      <div className="library-facility">
        <Underline heading="Other Facilities" />
        <Listformat points={libraryfacility} />
      </div>
    </>
  );
}
